import { connect } from 'react-redux';
import { closeLoginTooManySessionsModal } from './TooManySessionsModalActions';
import TooManySessionsModal from './TooManySessionsModal';

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(closeLoginTooManySessionsModal()),
});

export default connect(null, mapDispatchToProps)(TooManySessionsModal);
